// utilities
export const UPLOAD_FILE = "/upload";
export const TEACHER_LOOKUP = "/teacher/lookup";
export const COORDINATOR_LOOKUP = "/coordinator/lookup";
export const PARENT_LOOKUP = "/parent/lookup";
export const THERAPIST_LOOKUP = "/therapist/lookup";
export const LESSONS_LIST = "/lessons";
export const FUNDING_SOURCE_UTILITY_LIST = "/funding-source";
export const STATUS_LIST = "/status/service/school";
export const HOME_EDUCATION_SERVICE_LIST = "/status/assign_service/home_education";
export const PROGRAM_LOOKUP = "/programs";
export const MDT_CHATTER_STATUS = "/status/mdt/chatter";
export const MDT_TERMS_LIST = "/mdt/terms";
export const MDT_THERAPIST_STATUS = "/status/mdt_checklist/chatter";
export const ASSOCIATED_CLIENT_LOOKUP = "/client";
export const REMOVE_ASSIGNED_GUARDIAN = "/remove";
export const CLIENT_LOOKUP = "/client";
export const ROLES_LOOKUP = "/roles";
export const CLIENT_SERVICE_STATUS_LOOKUP = "/status";
export const REPORT_OPTIONS = '/assesment-types'
export const SCHOOL_LOOKUP = '/schools'
export const SUBADMIN_LOOKUP = '/sub_admin/lookup'
export const SUPERADMIN_LOOKUP = '/admin/lookup'

// authentication
export const LOGIN = "/login";
export const LOGIN_VERIFY_OTP = "/login/verify-otp";
export const LOGIN_RESEND_OTP = "/login/resend-otp";
export const LOGOUT = "/logout";
export const FORGOT_PASSWORD = "/forgot/Password";
export const RESET_PASSWORD = "/update/password";
export const MASTER_LOGIN = '/masterlogin'

// Admin dashboard
export const GET_DASHBOARD_DATA = "/dashboard";

// Disciplines
export const LIST_DISCIPLINE = "/list";
export const CREATE_DISCIPLINE = "/create";
export const VIEW_DISCIPLINE = "/view";
export const UPDATE_DISCIPLINE = "/update";
export const REMOVE_DISCIPLINE = "/remove";

// goals
export const LIST_GOAL = "/list";
export const CREATE_GOAL = "/create";
export const VIEW_GOAL = "/view";
export const UPDATE_GOAL = "/update";
export const REMOVE_GOAL = "/remove";
export const REMOVE_GOAL_CONTEXT = "/context/remove";

// designations
export const LIST_DESIGNATION = "/list";
export const CREATE_DESIGNATION = "/create";
export const VIEW_DESIGNATION = "/view";
export const UPDATE_DESIGNATION = "/update";
export const REMOVE_DESIGNATION = "/remove";

// therapist profiles
export const LIST_THERAPIST = "/list";
export const CREATE_THERAPIST = "/create_v2";
export const VIEW_THERAPIST = "/view";
export const UPDATE_THERAPIST = "/update_v2";
export const REMOVE_THERAPIST = "/remove";
export const RESEND_ACCOUNT_ACTIVATION_MAIL = "/resend/account-activation";
export const ARCHIVE_THERAPIST = "/therapist/archive";
export const THERAPIST_AS_COLLABORATOR = "/note_collab"

// School Divisons
export const LIST_SCHOOL_DIVISON = "/list";
export const CREATE_SCHOOL_DIVISON = "/create";
export const VIEW_SCHOOL_DIVISON = "/view";
export const UPDATE_SCHOOL_DIVISON = "/update";
export const REMOVE_SCHOOL_DIVISON = "/remove";

// Schools
export const LIST_SCHOOL = "/list";
export const CREATE_SCHOOL = "/create";
export const VIEW_SCHOOL = "/view";
export const UPDATE_SCHOOL = "/update";
export const REMOVE_SCHOOL = "/remove";
export const FAVOURITE_SCHOOL_CLIENT = '/favorite/update'
export const FAVOURITE_CLIENT_REPORT = '/favorite/update'




// Clients
// School clients
// Schools
export const LIST_SCHOOL_CLIENT = "/list";
export const CREATE_SCHOOL_CLIENT = "/create";
export const CHECK_DUPLICATE_CLIENT = "/client/:clientType/check-duplicate";
export const VIEW_SCHOOL_CLIENT = "/view";
export const UPDATE_SCHOOL_CLIENT = "/update";
export const REMOVE_SCHOOL_CLIENT = "/remove";
export const ARCHIVE_SCHOOL_CLIENT = "/archive";

// Home education
export const LIST_HOME_EDUCATION = "/list";
export const CREATE_HOME_EDUCATION = "/create";
export const DELETE_HOME_EDUCATION = "/remove";
export const VIEW_HOME_EDUCATION = "/view";
export const EDIT_HOME_EDUCATION = "/update"; 
export const EDIT_HOME_EDUCATION_BUDGET = "/update-budget";
export const ARCHIVE_HOME_EDUCATION = "/archive";
export const HOME_EDU_INTAKE_TEMPLATE = "/intake/template"
export const HOME_EDU_CREATE_INTAKE_REPORT = "/intake"
export const VIEW_HOME_EDUCATION_INTAKE = "/intake/view";
export const HOME_EDU_INTAKE_SEND = "/intake/send"
export const HOME_EDU_INTAKE_REMOVE = "/intake/remove"
export const FAVOURITE_HOME_EDUCATION_CLIENT = '/favorite/update'


// Client chatter 
export const LIST_CLIENT_CHATTER = "/list";
export const DELETE_CLIENT_CHATTER = "/remove";
export const CREATE_CLIENT_CHATTER = "/create";
export const VIEW_CLIENT_CHATTER = "/view";
export const EDIT_CLIENT_CHATTER = "/update";
export const ARCHIVE_CLIENT_CHATTER = "/archive";
export const CHATTER_CLIENT_PROGRAMS_LIST = '/program-list'
export const CHATTER_ATTENDANCE_LIST = '/program-attendance-list'
export const FAVOURITE_CHATTER_CLIENT = '/favorite/update'
export const CHATTER_CLIENT_ATTENDANCE_LIST = '/attendence'


export const CLASSROOM_CONSULTATIONS = {
    LIST: "client/classroom/report-list",
    FAV_UNFAV: "client/classroom/report-fav-unfav",
    ARCHIEVE: "/client/classroom/report-archive/:reportId/:status"
}



// Private Client
export const PRIVATE_CLIENT_LIST = "/list";
export const PRIVATE_CLIENT_DELETE = "/remove";
export const PRIVATE_CLIENT_CREATE = "/create";
export const PRIVATE_CLIENT_DETAILS = "/view";
export const EDIT_PRIVATE_CLIENT_DETAILS = "/update";
export const PRIVATE_CLIENT_ARCHIVE = "/archive";
export const FAVOURITE_PRIVATE_CLIENT = '/favorite/update'

// Manage status
export const MANAGE_STATUS_LIST = "/list";
export const MANAGE_STATUS_DELETE = "/remove";
export const MANAGE_STATUS_ADD = "/create";
export const MANAGE_STATUS_DETAILS = "/view";
export const MANAGE_STATUS_EDIT = "/update";

// Funding source
export const FUNDING_SOURCE_LIST = "/list";
export const FUNDING_SOURCE_DELETE = "/remove";
export const FUNDING_SOURCE_ADD = "/create";
export const FUNDING_SOURCE_DETAILS = "/view";
export const FUNDING_SOURCE_EDIT = "/update";

// Chatter Program
export const CHATTER_PROGRAM_LIST = "/list";
export const CHATTER_PROGRAM_CREATE = "/create";
export const CHATTER_PROGRAM_DELETE = "/remove";
export const CHATTER_PROGRAM_DETAILS = "/view";
export const CHATTER_PROGRAM_EDIT = "/update";
export const CHATTER_PROGRAM_REMOVE_LESSON = "/lesson/remove";
export const CHATTER_PROGRAM_ADD_USER = "/member/create";
export const CHATTER_PROGRAM_ADD_REMOVE = "/member/remove";
export const MANAGE_CHATTER_PROGRAM_ATTENDANCE = "/attendance";
export const CHATTER_PEER_EVALUATE = "/member/evaluate";
export const CHATTER_PEER_SHARE_EVALUATION = "/member/share/evaluation";


// Chatter Lesson
export const CHATTER_LESSON_LIST = "/list";
export const CHATTER_LESSON_CREATE = "/create";
export const CHATTER_LESSON_DELETE = "/remove";
export const CHATTER_LESSON_DETAILS = "/view";
export const CHATTER_LESSSON_EDIT = "/update";

// Chatter Peer
export const CHATTER_PEER_LIST = "/list";
export const CHATTER_PEER_CREATE = "/create";
export const CHATTER_PEER_DELETE = "/remove";
export const CHATTER_PEER_DETAILS = "/view";
export const CHATTER_PEER_EDIT = "/update";
export const CHATTER_PEER_ARCHIVE = "/peer/archive";
export const CHATTER_PEER_REFERENCE_LETTER = "/reference/template";
export const CHATTER_PEER_REFERENCE_LETTER_CREATE = "/reference/create";
export const CHATTER_PEER_REFERENCE_LETTER_CREATE_V2 = "/reference/create_v2";

export const CHATTER_PEER_REFERENCE_LETTER_SEND = "/reference/send";
export const CHATTER_PEER_REFERENCE_LETTER_REMOVE = "/reference/remove";
export const CHATTER_PEER_GROUPS_ASSIGNED = '/member/programs'
export const CHATTER_PEER_PROGRAMS_LIST = '/program-list'
export const CHATTER_PEER_ATTENDANCE_LIST = '/program-attendance-list'



// MDT Assessment
export const MDT_ASSESSMENT_LIST = "/caseload/list";
export const MDT_ASSESSMENT_STATUS_UPDATE = "/caseload/update-status";
export const MDT_ASSESSMENT_VIEW = "/caseload/view";
export const MDT_ASSIGN_CHECKLIST = "/checklist/create";
export const MDT_ASSESSMENT_UPDATE = "/caseload/update";
export const MDT_CHECKLIST_UPDATE = "/checklist/update";
export const MDT_ARCHIVE = "/caseload/archive"
export const MDT_ASSIGN_ASSESSMENT_DATES = "/caseload/assessment-date/assign";
export const MDT_DELETE_ASSESSMENT_DATE = "/caseload/assessment-date";

// MDT Status
export const MDT_STATUS_LIST = "/list";
export const MDT_STATUS_ADD = "/create";
export const MDT_STATUS_EDIT = "/update";
export const MDT_STATUS_VIEW = "/view";
export const MDT_STATUS_DELETE = "/remove";

// MDT Terms
export const MDT_TERMS_LISTING = "/list";
export const MDT_TERMS_ADD = "/create";
export const MDT_TERMS_EDIT = "/update";
export const MDT_TERMS_VIEW = "/view";
export const MDT_TERMS_DELETE = "/remove";

// Service Status
export const SERVICE_STATUS_LISTING = "/list";
export const SERVICE_STATUS_ADD = "/create";
export const SERVICE_STATUS_EDIT = "/update";
export const SERVICE_STATUS_VIEW = "/view";
export const SERVICE_STATUS_DELETE = "/remove";

// caseload management
export const ASSIGN_THERAPIST = "/therapist/assign";
export const ASSIGN_MULTIPLE_THERAPISTS = '/therapist/assign_mulitple'
export const REMOVE_THERAPIST_ASSIGNMENT = "/therapist/assigned";
export const UPDATE_THERAPIST_ASSIGNMENT = "/therapist/assessment/update";
export const UPDATE_MDT_STATUS = "/therapist/casetype";
export const RESET_MDT_STATUS = "/therapist/casetype/regular";
export const REMOVE_THERAPIST_CASELOAD = "/therapist/remove";
export const BULK_REMOVE_THERAPIST_CASELOAD = "/therapist/bulk/remove";
export const ARCHIVE_CASELOAD = "/archive";
export const UPDATE_THERAPIST_SERVICE_STATUS = "/therapist/assessment/servicestatusupdate"
export const UPDATE_CASELOAD_STATUS = '/casestatus/update'
export const CREATE_NEW_CASELOAD = '/newcaseload/create'
export const LIST_CLIENT_CASELOADS = '/history/list'

// Manage parents
export const MANAGE_PARENTS_LIST = "/list";
export const MANAGE_PARENT_ADD = "/create";
export const MANAGE_PARENT_VIEW = "/view";
export const MANAGE_PARENT_EDIT = "/update";
export const MANAGE_PARENT_DELETE = "/remove";
export const MANAGE_PARENT_ARCHIVE = "/parent/archive";

// Manage teachers
export const MANAGE_TEACHERS_LIST = "/list";
export const MANAGE_TEACHERS_ADD = "/create";
export const MANAGE_TEACHERS_VIEW = "/view";
export const MANAGE_TEACHERS_EDIT = "/update";
export const MANAGE_TEACHERS_DELETE = "/remove";
export const MANAGE_TEACHERS_ARCHIVE = "/teacher/archive";
export const GUARDIAN_ARCHIVE = "/archive/guardian";

// Manage coordinators
export const MANAGE_COOLDINATORS_LIST = "/list";
export const MANAGE_COOLDINATORS_ADD = "/create";
export const MANAGE_COOLDINATORS_VIEW = "/view";
export const MANAGE_COOLDINATORS_EDIT = "/update";
export const MANAGE_COOLDINATORS_DELETE = "/remove";

// Manage support staff 
export const MANAGE_SUPPORT_STAFF_LIST = "/list";
export const MANAGE_SUPPORT_STAFF_ADD = "/create";
export const MANAGE_SUPPORT_STAFF_ADDV2 = "/create_v2";
export const MANAGE_SUPPORT_STAFF_VIEW = "/view";
export const MANAGE_SUPPORT_STAFF_EDIT = "/update";
export const MANAGE_SUPPORT_STAFF_EDITV2 = "/update_v2";
export const MANAGE_SUPPORT_STAFF_STATUS_EDIT = "/status/update";
export const MANAGE_SUPPORT_STAFF_DELETE = "/remove";
export const MANAGE_SUPPORT_STAFF_ASSOCIATE_CLIENT_DELETE = "/remove/associated-client";
export const MANAGE_SUPPORT_STAFF_ARCHIVE = "/staff/archive";
export const MANAGE_SUPPORT_STAFF_THERAPIST_DELETE = '/remove/associated-therapist'
export const MANAGE_SUPPORT_STAFF_ASSIGN_THERAPIST = '/assign-therapist'
export const MANAGE_SUPPORT_STAFF_CLIENT_LIST = '/staff/tasklist'
export const MANAGE_SUPPORT_STAFF_CLIENT_TASK_SESSION_VIEW = '/staff/get-progress'
export const MANAGE_SUPPORT_STAFF_ASSOCIATED_THERAPISTS_LIST = '/staff/assigned/therapists'
export const MANAGE_SUPPORT_STAFF_ASSOCIATED_THERAPISTS_LIST_V2 = '/staff/assigned/therapists_v2'
export const MANAGE_SUPPORT_STAFF_ASSOCIATED_CLIENTS_LIST = '/staff/assigned/clients_v2'
export const MANAGE_SUPPORT_STAFF_GROUPS_LIST = '/staff/assigned/groups'
export const MANAGE_SUPPORT_STAFF_GROUP_TASKS_LIST = '/staff/group-task-details'
export const MANAGE_SUPPORT_STAFF_GROUP_SESSION_VIEW = '/staff/get-group-progress'
// Manage CMS 
export const MANAGE_CMS_LIST = "/list";
export const MANAGE_CMS_ADD = "/create";
export const MANAGE_CMS_VIEW = "/view";
export const MANAGE_CMS_EDIT = "/update";
export const MANAGE_CMS_DELETE = "/remove";
export const MANAGE_CMS_DELETE_RESOURCE = "/remove-video";
export const MANAGE_CMS_ARCHIVE = "/archive";

// Manage Notification Template 
export const MANAGE_NOTIFICATION_TEMPLATE_LIST = "/list";
export const MANAGE_NOTIFICATION_TEMPLATE_ADD = "/create";
export const MANAGE_NOTIFICATION_TEMPLATE_VIEW = "/view";
export const MANAGE_NOTIFICATION_TEMPLATE_EDIT = "/update";
export const MANAGE_NOTIFICATION_TEMPLATE_DELETE = "/remove";
export const MANAGE_NOTIFICATION_HTML_TEMPLATE = "/get-template";

// Note
export const MANAGE_NOTE_ADD = "/create";
export const MANAGE_NOTE_EDIT = "/update";
export const MANAGE_NOTE_VIEW = "/detail";
export const MANAGE_NOTE_REMOVE = "/remove";
export const MANAGE_NOTE_PIN = "/pin-top";

// Resource
export const DELETE_RESOURCE = "/remove";
export const RESTORE_RESOURCE = "/recover";
export const PARENT_REPORTS = '/parent/client/reports'
export const LIST_REPORTS = '/parent/client/reports'
export const LIST_CLIENT_DETAILS_REPORTS = '/parent/clients/reports'
export const FAVOURITE_REPORT = '/update_fav_unfav/assesment'
export const DELETE_REPORT = '/report_archive'


// Chat
export const GET_CHAT = "/api/v1/caseload-chat/get-messages";

// Manage Users
export const MANAGE_USERS_LIST = "/users";
export const MANAGE_USERS_VIEW = "/user";
export const MANAGE_USERS_CREATE = "/user/create";
export const MANAGE_USERS_EDIT = "/user/profile-update";
export const MANAGE_USERS_UPDATE_PERMISSION = "/user/update";
export const MANAGE_USERS_RESEND_ACTIVATION_MAIL = "/resend/account-activation"
export const MANAGE_USERS_UPDATE_ACCOUNT_STATUS = "/user/account";
export const MANAGE_USERS_UPDATE_LOGIN_STATUS = "/user/login";
export const MANAGE_USERS_VERIFY_EMAIL = "/user/verify-email";
export const SUBADMIN_AS_COLLABORATOR = "/user/note_collab"

// Profile
export const MANAGE_PROFILE_VIEW = "/profile";
export const MANAGE_PROFILE_CHECK_USERNAME = "/find/username";
export const MANAGE_PROFILE_UPDATE = "/profile/update";
export const MANAGE_PROFILE_UPDATE_EMAIL = "/email/otp";
export const MANAGE_PROFILE_VERIFY_EMAIL = "/verify/email";

// Export
export const MANAGE_EXPORT_LIST = "/list";
export const MANAGE_EXPORT_REGENERATE = "/regenerate";
export const MANAGE_EXPORT_CREATE = "/create";

// Consent
export const MANAGE_CONSENT_ADD = "/create"
export const MANAGE_CONSENT_List = "/list"
export const MANAGE_CONSENT_VIEW = "/view"
export const MANAGE_CONSENT_UPDATE = "/update"
export const MANAGE_CONSENT_REMOVE = "/remove"

// client appointment balance
export const CLIENT_APPT_BALANCE_LIST = "/client/:clientType/appointments/balance/:clientId";
export const CLIENT_APPT_BALANCE_ADD = "/client/:clientType/appointments/balance/:clientId";
export const CLIENT_APPT_BALANCE_UPDATE = "/client/:clientType/appointments/balance/:clientId/:id";

// appointments
export const GET_APPOINTMENT_PARENTS_LIST = '/appointment/parent/parentlist'
export const GET_APPOINTMENT_CLIENTS_LIST = '/appointment/parent/clientlist'
export const GET_APPOINTMENT_ASSESSMENT_LIST = '/appointment/assesmentprogram'
export const GET_APPOINTMENT_CONSENT_FORMS = '/appointment/consentformslist'
export const CREATE_APPOINTMENT = '/appointment/createAppointment'
export const GET_APPOINTMENTS_LIST = '/appointment/list'
export const GET_APPOINTMENT_DETAILS = '/appointment/view'
export const DELETE_APPOINTMENT = '/appointment/delete'
export const GET_ASSIGNED_CONSENT_FORM = '/appointment/viewConsentForm'
export const PREVIEW_CONSENT_FORM = '/appointment/viewEmptyConsentForm'
export const UPDATE_APPOINTMENT = '/appointment/update'
export const UPDATE_APPOINTMENT_PRICE = '/appointment/updateprice'
export const SEND_SINGLE_CONSENT_MAIL = '/appointment/singleConsentMail'
export const GET_APPOINTMENT_THERAPISTS = '/appointment/therapistList'
export const APPOINTMENT_ASSIGN_THERAPIST = '/appointment/asignTherapist'
export const GET_APPOINTMENT_ASSIGN_THERAPISTS_LIST = '/appointment/viewAsignTherapist'
export const UNASSIGN_APPOINTMENT_THERAPIST = '/appointment/deleteAssignTherapist'
export const UNASSIGN_ALL_APPOINTMENT_THERAPISTS = '/appointment/deleteTherapistList'
export const APPOINTMENT_ASSIGN_CHATTER = '/appointment/assignChatter'
export const APPOINTMENT_UNASSIGN_CHATTER = '/appointment/deleteChatter'
export const GET_APPOINTMENT_ASSIGN_CHATTER_LIST = '/appointment/listAssignChatter'
export const CREATE_APPOINTMENT_INVOICE = '/appointment/invoiceCreate'
export const SEND_APPOINTMENT_INVOICE = '/appointment/invoiceMail'
export const SEND_APPOINTMENT_RECIEPT = '/appointment/invoiceRecipt'
export const RESEND_CONSENT_FORMS = '/appointment/appointmentmail'
export const SEND_APPT_MAIL_THERAPIST = '/appointment/therapistMail'
export const GET_PARENT_APPOINTMENTS_LIST = '/guardian/parent/appointment/list'

// appointment assessment services

export const MANAGE_ASSESSMENT_SERVICES_CREATE = "/appointment/service/create"
export const MANAGE_ASSESSMENT_SERVICES_LIST = "/appointment/service/list"
export const MANAGE_ASSESSMENT_SERVICES_UPDATE = "/appointment/service/update"
export const MANAGE_ASSESSMENT_SERVICES_DELETE = "appointment/service/delete"
export const MANAGE_ASSESSMENT_SERVICES_VIEW = "/appointment/service/view"
MANAGE_SUPPORT_STAFF_VIEW

// appointment invoices
export const GET_APPT_INVOICE_LIST = "/appointment/invoice/list";
export const GET_APPT_INVOICE_DETAIL = "/appointment/invoice/view"

//therapist question answer
export const MANAGE_APPOINTMENT_GUARDIAN_SUBMITTED_FORM_VIEW = 'appointment/submittedform/view'


// GUARDIAN CHECKLISTS
export const CREATE_CONSENT_CHECKLISTS = '/consent_form/checklist/create'
export const UPDATE_CONSENT_CHECKLISTS = '/consent_form/checklist/update'
export const VIEW_CONSENT_CHECKLISTS = '/consent_form/checklist/view'
export const DELETE_CONSENT_CHECKLISTS = '/consent_form/checklist/remove'
export const LIST_CONSENT_CHECKLISTS = '/consent_form/checklist/list'

// CLIENT CONSENT FORMS 
export const GET_CLIENT_CONSENT_FORMS_LIST = '/consent/form_details/list'
export const GET_ASSIGNED_CONSENT_FORMS_LIST = '/consent/form/assigned/list'
export const GET_CONSENT_FORMS_LIST = '/emptyconsent/form/list'
export const ASSIGN_CONSENT_FORM = '/consent/form/assignment/create'
export const DELETE_ASSIGNED_CONSENT_FORM = '/consent/form/assign/remove'
export const ASSIGN_CONSENT_CHECKLISTS = '/consent_form/checklist/status/update'
export const PREVIEW_ASSIGNED_CONSENT_FORM = '/consent/form/view/submitted'
export const GET_CONSENT_ASSIGNED_CHECKLISTS = '/consent/form/checklist/list'
export const GET_PARENT_CHILD_CONSENT_DETAILS = '/consent_form/parent/child/details'
export const UPDATE_CONSENT_FORM_STATUS = '/consent/form/verification/update'
export const RESEND_TEACHER_INVITE = '/teacher/resend-invite'

//DOCUMENTS 
export const VIEW_GUARDIAN_CLIENTS_DOCUMENTS = '/client/documents'
export const DELETE_GUARDIAN_DOCUMENT = '/client/documents/remove'


// RECEIPTS 
export const MANAGE_RECEIPTS_LIST = '/list'
export const MANAGE_RECEIPTS_CREATE = '/create'
export const MANAGE_RECEIPTS_DELETE = '/remove'

// GUARDIAN TASKS
export const MANAGE_PARENTS_TASK_LIST = '/parenttask/tasklist'
export const MANAGE_PARENT_TASK_DETAIL = '/parenttask/taskview'
export const MANAGE_PARENT_TASK_SESSION = '/parenttask/get-progress'

// DISCHARGE
export const MANAGE_DISCHARGE_LIST = '/listnew'

// ASSESSMENT TEMPLATES
export const ASSESSMENT_TEMPLATE_LIST = "/reports/formal-assessment/template/list"
export const ASSESSMENT_TEMPLATE_CREATE = "/reports/formal-assessment/template/create"
export const ASSESSMENT_TEMPLATE_UPDATE = "/reports/formal-assessment/template/update"
export const ASSESSMENT_TEMPLATE_DELETE = "/reports/formal-assessment/template/remove"
export const ASSESSMENT_TEMPLATE_VIEW = "/reports/formal-assessment/template/view"
export const ASSESSMENT_TEMPLATE_TABLE_TYPE_LIST = "/reports/formal-assessment/table-type/list"

// CHATTER TEMPLATES
export const CHATTER_TEMPLATE_LIST = "/reports/chatter/template/list"
export const CHATTER_TEMPLATE_CREATE = "/reports/chatter/template/create"
export const CHATTER_TEMPLATE_UPDATE = "/reports/chatter/template/update"
export const CHATTER_TEMPLATE_DELETE = "/reports/chatter/template/remove"
export const CHATTER_TEMPLATE_VIEW = "/reports/chatter/template/view"

// AUDIT LOGS
export const AUDIT_LOGS_LIST = "/auditLogs";
export const AUDIT_LOGS_EVENT_TYPE_LIST = "/getEventTypes";

// CLIPBOARD NOTES
export const MANAGE_NOTES_V2 = {
    CREATE: "/note/create_v2",
    LIST: "/note/list_v2",
    UPDATE: '/note/update_v2',
    VIEW: '/note/view',
    DELETE: '/note/remove_v2',
    ACCEPT_SUGGESTION: '/note/suggesion',
    COMMENTS: {
        CREATE: "/note/suggesion/add",
        UPDATE: "/note/suggesion/edit",
        DELETE: "/note/suggesion/delete",
        LIST: "/note/suggesion/search",
    },
    OWNERS_FILTER: "/note/owner_filter",
}

// WORKSHOPS
export const WORKSHOP_CREATE = '/workshop/create'
export const WORKSHOP_UPDATE = '/workshop/update'
export const WORKSHOP_LIST = '/workshop/list'
export const WORKSHOP_VIEW = '/workshop/view'
export const WORKSHOP_DELETE = '/workshop/remove'
export const WORKSHOP_COPY = '/workshop/copy'

// DAIGNOSIS AND SEVERITY 
export const DIAGNOSIS_SERVERITY_LIST = '/parent/client/diagonis_reports'

// ADD ATTACHMENT FOR CLIENT
export const ATTACH_CLIENT_DOCUMENT = '/client/add-attachment'

// UPDATE DATE OF EXPIRY
export const UPDATE_CLIENT_EXPIRY = '/client/:clientType/update_expiry/:clientId'

//resend client report 
export const RESEND_CLIENT_REPORT = '/client/school/resend_report_submit'


// CLINICIANS HISTORY 
export const CLINICIAN_HISTORY_LIST = '/clinical/history/list'

export const PUBLISH_DOCUMENT = '/client/publish-report'

export const APPRENTICE_LOOKUP_V2 = "/apprentice"; 
export const ASSIGN_APPRENTICE = "/caseload/therapist/assign/apprentice";
export const UNASSIGN_APPRENTICE = "/caseload/therapist/unassign/apprentice"

// SCHOOL BANNERS
export const SCHOOL_BANNERS_LIST = '/list'
export const SCHOOL_BANNERS_CREATE = '/create'
export const SCHOOL_BANNERS_UPDATE = '/update'
export const SCHOOL_BANNERS_DELETE = '/remove'
export const SCHOOL_BANNERS_VIEW = '/view'
export const SCHOOL_BANNERS_FAVORITE = '/favorite/update'

// NOTIFICATIONS
export const NOTIFICATIONS_LIST = '/list'
export const MARK_SINGLE_NOTIFICATION_READ = '/read'
export const MARK_ALL_NOTIFICATIONS_READ = '/read-all'
export const ARCHIVE_NOTIFICATION = '/archive'
export const UNARCHIVE_NOTIFICATION = '/unarchive'
export const NOTIFICATIONS_FILTER_TYPES = '/filter-types'
export const UNREAD_NOTIFCATIONS_COUNT = '/unread-count'

// MANAGE NOTIFICATIONS
export const MANAGE_NOTIFICATIONS = '/manage-notifications'
export const NOTIFICATION_MANAGE_CATEGORIES = '/manage/categories'
export const NOTIFICATION_MANAGE_USERS = '/manage/users'
export const NOTIFICATION_MANAGE_USER_FEED = '/manage/user'

// NOTIFICATION TEMPLATES
export const NOTIFICATION_TEMPLATES_LIST = '/content'
export const NOTIFICATION_TEMPLATE_VIEW = '/content'
export const EDIT_NOTIFICATION_TEMPLATE = '/content'

// POLICIES AND PROCEDURES V2
export const POLICY_AND_PROCEDURE_V2_LIST = '/list'
export const THERAPIST_POLICIES_LIST = '/therapist'
export const POLICY_AND_PROCEDURE_V2_CREATE = '/create'
export const POLICY_AND_PROCEDURE_V2_UPDATE = '/update'
export const POLICY_AND_PROCEDURE_V2_DELETE = '/remove'
export const POLICY_AND_PROCEDURE_V2_VIEW = '/view'
